
import { useState } from 'react';

interface HeaderProps {
  cartItemsCount?: number;
}

export default function Header({ cartItemsCount = 0 }: HeaderProps) {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-md z-40">
      <div className="px-4 py-3">
        {/* Top Row - Logo and Cart */}
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center">
            <button className="w-10 h-10 bg-[#D4AF37]/10 rounded-full flex items-center justify-center ml-3">
              <i className="ri-menu-line text-[#4B2E05] text-xl"></i>
            </button>
          </div>
          
          <div className="text-center">
            <h1 className="text-xl font-bold text-[#4B2E05]" style={{ fontFamily: '"Pacifico", serif' }}>
              عبدالرحمن
            </h1>
            <p className="text-xs text-[#777777]">قهوة فاخرة</p>
          </div>
          
          <div className="flex items-center">
            <button className="relative w-10 h-10 bg-[#D4AF37]/10 rounded-full flex items-center justify-center">
              <i className="ri-shopping-cart-line text-[#4B2E05] text-xl"></i>
              {cartItemsCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-[#D4AF37] text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-medium">
                  {cartItemsCount > 99 ? '99+' : cartItemsCount}
                </span>
              )}
            </button>
          </div>
        </div>

        {/* Search Bar */}
        <div className="relative">
          <input
            type="text"
            placeholder="ابحث عن القهوة والأدوات..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full bg-[#F5F5F5] border-none rounded-full py-3 px-4 pr-12 text-sm text-right placeholder-[#777777] focus:outline-none focus:ring-2 focus:ring-[#D4AF37]/30"
            dir="rtl"
          />
          <button className="absolute right-3 top-1/2 transform -translate-y-1/2 w-8 h-8 bg-[#D4AF37] rounded-full flex items-center justify-center">
            <i className="ri-search-line text-white text-sm"></i>
          </button>
        </div>
      </div>
    </header>
  );
}
